import { AppBarProps, Box, ToolbarProps, styled } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { IconMenu2 } from "@tabler/icons-react";
import { Spacer } from "common";
import { ReactNode } from "react";
//@ts-ignore
import { ReactComponent as SvgMobileLogo } from "assets/logo.svg";
import AvatarIconButton from "components/AvatarIconButton/AvatarIconButton";
import I18n from "i18n-js";

const MobileLogo = styled(SvgMobileLogo)`
  width: 36px;
  height: 36px;
`;
export interface HeaderProps extends Omit<AppBarProps, "title"> {
  title?: String;
  right?: ReactNode;
  logo?: ReactNode;
  content?: ReactNode;
  onMenuClick?: () => void;
  showMenuButton?: boolean;
  toolbarProps?: ToolbarProps;
  open?: boolean;
  mdUp?: boolean;
  setOpen?: (open?: boolean) => void;
}

export default function Header({
  title,
  logo,
  right,
  onMenuClick,
  showMenuButton,
  toolbarProps,
  content,
  open,
  setOpen,
  mdUp,
  ...rest
}: HeaderProps) {
  return (
    <AppBar
      position="fixed"
      color="transparent"
      elevation={0}
      sx={{
        zIndex: theme => theme.zIndex.drawer + 1,
        //backgroundColor: "background.paper",
        //backgroundColor: theme => alpha(theme.palette.background.default, 0.9),
        backgroundColor: "none",
        pointerEvents: "none",
        //     borderRadius: theme => `${theme.shape.borderRadius}px`,

        //backgroundImage: theme => `radial-gradient(815px at 23.4% -21.8%, ${theme.palette.background.paper} 0.2%, ${theme.palette.background.default} 100.2%);`,
      }}
      {...rest}
    >
      <Toolbar {...toolbarProps}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "218px",
          }}
        >
          {<MobileLogo />}
          <Spacer w={1} />
          <Typography variant="h4" noWrap component="div">
            {I18n.t("App.title")}
          </Typography>
          <Spacer right />
          <AvatarIconButton
            onClick={() => {
              if (mdUp) {
                setOpen && setOpen(!open);
              } else {
                onMenuClick && onMenuClick();
              }
            }}
            sx={{
              pointerEvents: "auto",
            }}
          >
            <IconMenu2 />
          </AvatarIconButton>
        </Box>
        {!!content && (
          <>
            <Spacer w={1} />
            {content}
          </>
        )}
        <Spacer right />
        <Spacer w={1} />
        {right}
      </Toolbar>
    </AppBar>
  );
}
